// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileFollowingNav{display:flex;padding:5px 0 5px 5px;width:100%}.MobileFollowingNav .followLink{padding-right:15px;margin:0}.MobileFollowingNav .followLink.active{font-family:"UbuntuBold",Arial,Helvetica,sans-serif}.MobileFollowingNav .followLink:not(.active){margin-top:1px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
